export const generatePinpointKey = <T extends string | undefined | null>(
  pinpointField: T,
): T extends string ? string : null => {
  if (pinpointField && typeof pinpointField === 'string') {
    return `pinpoint_key_${pinpointField}` as T extends string ? string : null;
  }
  return null as T extends string ? string : null;
};
